import React from "react";
import { Helmet } from "react-helmet";
import { Route, Routes } from "react-router-dom";
import Layout from "../../Layouts";
import { sortSettings } from "../../Utils/functions";
import Dashboard from "../Dashboard";
import Form from "../Form";
import NotFound from "../NotFound";
import Support from "../Support";
import Surfaces from "../Surfaces";
import Table from "../Table";
export const stracture = {
  // fas fa-shopping-cart
  // fab fa-figma
  pages: [
    {
      label: "داشبورد",
      icon: "fab fa-trello",
      route: "/",
      nested: false,
      options: [
        {
          route: "/",
          type: "dashboard",
          elements: [],
        },
      ],
    },

    {
      icon: "fas fa-shopping-cart",
      nested: false,
      route: "/orders",
      label: "لیست سفارشات",

      options: [
        {
          route: "/orders",
          type: "table",
          show: true,
          label: "لیست سفارشات",
          api: {
            route: "/peyemtn/list",
          },
          filters: [
            {
              key: "status",
              type: "select",
              options: [
                {
                  label: "موفق",
                  key: "success",
                },
                {
                  label: "در انتظار پرداخت",
                  key: "waittopey",
                },
                {
                  label: "ناموفق",
                  key: "error",
                },
                {
                  label: "رها شده",
                  key: "abandoned",
                },
              ],
            },
          ],
          actions: [
            {
              type: "show",
              link: "/orders",
              label: "جزییات شفارش",
              keyGo: "id",
            },
          ],
          header: [
            {
              key: "fullname",
              label: "نام",
              type: "nested",
              objectKey: "client",
            },

            {
              key: "mobile",
              label: "موبایل",
              type: "nested",
              objectKey: "client",
            },
            {
              key: "growth_price",
              label: "مبلغ",
            },
            {
              key: "trackingcode",
              label: "کد پیگیری",
            },
            {
              key: "product_name",
              label: "نام محصول",
              // type: "nested",
              // objectKey: "cource",
            },
            {
              key: "status",
              label: "وضعیت",
              type: "enum",
              enum: {
                waittopey: "در انتظار پرداخت",
                success: "موفق",
                error: "مشکل پرداخت",
                abandoned: "رها شده",
              },
            },
            {
              key: "created_at",
              label: "زمان",
              type: "date",
            },
          ],
        },
        {
          route: "/orders/:id",
          type: "surface",
          surfaceType: "orderDetails",
          label: "جزیيات سفارش",
          key: "id",
          api: {
            route: "/user/peyment",
          },
          header: [],
        },
      ],
    },

    {
      icon: "far fa-comments",
      nested: false,
      route: "/comments",
      label: "نقد و نظرات",
      options: [
        {
          route: "/comments",
          type: "table",
          show: true,
          label: "",
          api: {
            route: "/comment/adminlist",
          },
          filters: [
            {
              type: "select",
              options: [
                {
                  key: "on",
                  label: "فعال",
                },
                {
                  key: "off",
                  label: "غیر فعال",
                },
              ],
              key: "status",
            },
            {
              type: "select",
              options: [
                {
                  key: "wait",
                  label: "منتظر پاسخ",
                },
                {
                  key: "done",
                  label: "پاسخ داده شده",
                },
              ],
              key: "reply",
            },
          ],
          actions: [
            {
              type: "reply",
              key: "comment_id",
              route: "/comment/adminreply",
              label: "پاسخ",
            },
            {
              type: "toggle",
              depened: {
                key: "status",
                on: "غیر فعال کردن نظر",
                off: "فعال کردن نظر",
              },
              key: "comment_id",
              route: "/comment/toggle",
            },
            {
              type: "delete",
              label: "حذف آگهی",
              route: "/comment/delete",
              key: "comment_id",
            },
          ],
          header: [
            {
              key: "fullname",
              label: "نام",
              type: "nested",
              objectKey: "commenter",
            },

            {
              key: "mobile",
              label: "موبایل",
              type: "nested",
              objectKey: "commenter",
            },
            {
              key: "status",
              type: "enum",
              label: "وضعیت",
              enum: {
                on: "فعال",
                off: "غیر فعال",
              },
            },
            {
              key: "title",
              label: "برای",
              type: "nested",
              objectKey: "rel",
            },
            {
              key: "isreply",
              label: "پاسخ",
              type: "zero",
              enum: ["پاسخ داده شده", "منتظر پاسخ"],
            },
            {
              key: "user_type",
              label: "نوع کاربر ",
              type: "enum",
              enum: {
                admin: "ادمین",
                user: "کاربر",
                sales_manager: "مدیر فروش",
                sales_expert: "کارشناس فروش",
              },
            },
            {
              key: "text",
              type: "long",
              label: "متن",
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
          ],
        },
      ],
    },
    {
      icon: "fas fa-bell",
      nested: true,
      label: "آگهی ها",
      options: [
        {
          route: "/notif/create",
          type: "form",
          show: true,
          label: "ایجاد آگهی",
          api: {
            needs: ["tags", "categoriesChildrens"],
            // needs: ["categories", "options"],
            route: "/advertising/create",
          },

          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "content",
              label: "متن",
              type: "textarea",
            },
            {
              key: "category_id",
              label: "دسته بندی آگهی",
              type: "select",
              need: "categoriesChildrens",
              // need: "categories",
              isCategory: true,
            },
            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
            {
              key: "model",
              label: "نوع آگهی",
              type: "select",
              options: [
                {
                  name: "فروش",
                  key: "sale",
                },
                {
                  name: "درخواست",
                  key: "request",
                },
                {
                  name: "اجاره",
                  key: "rent",
                },
                {
                  name: "معرفی",
                  key: "introduction",
                },
                {
                  name: "خرید",
                  key: "buy",
                },
                {
                  name: "سایر",
                  key: "other",
                },
              ],
            },
            {
              key: "addres",
              label: "آدرس",
            },
            {
              key: "",
              type: "region",
              noNeed: true,
            },
            {
              key: "keywords",
              type: "keywords",
              label: "کلمات کلیدی",
            },
            {
              key: "type",
              label: "نوع آگهی دهنده",
              type: "select",
              options: [
                {
                  name: "شخصی",
                  key: "personal",
                },
                {
                  name: "شرکتی",
                  key: "company",
                },
              ],
            },
            {
              key: "fullname",
              label: "نام و نام خانوادگی",
              exist: {
                key: "type",
                value: "personal",
              },
              noNeed: true,
            },
            {
              key: "mobile",
              label: "موبایل",
              exist: {
                key: "type",
                value: "personal",
              },
              noNeed: true,
            },
            {
              key: "email",
              label: "ایمیل",
              exist: {
                key: "type",
                value: "personal",
              },
              noNeed: true,
            },

            {
              key: "co_name",
              label: "نام شرکت",
              exist: {
                key: "type",
                value: "company",
              },

              noNeed: true,
            },
            {
              key: "co_tell",
              label: "تلفن شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },
            {
              key: "co_mobile",
              label: "موبایل شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },
            {
              key: "co_addres",
              label: "آدرس شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },
            {
              key: "co_url",
              label: "وبسایت شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },

            {
              key: "price",
              label: "قیمت (تومان)",
            },

            {
              key: "main_image",
              label: "تصویر اصلی",
              type: "images",
            },
            {
              key: "product_images",
              label: "تصاویر دیگر",
              single: false,
              type: "images",
            },
          ],
        },

        {
          route: "/notif/list-progress",
          type: "table",
          show: true,
          label: "آگهی های در انتظار تایید",
          api: {
            route: "/advertising/admin_list_inproces",
          },
          actions: [
            {
              type: "delete",
              label: "حذف آگهی",
              route: "/notif/delete",
              key: "notif_id",
            },
            {
              type: "show",
              link: "/notif/update",
              label: "مشاهده آگهی",
            },
            {
              type: "reject",
              link: "/notif/update",
              label: "تغییر وضعیت آگهی",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "title",
              label: "دسته بندی",
              objectKey: "city",
            },

            {
              key: "updated_ay",
              type: "date",
              label: "آخرین ویرایش",
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
          ],
        },
        {
          route: "/notif/list-visible",
          type: "table",
          show: true,
          label: "آگهی های فعال",
          api: {
            route: "/advertising/admin_list_visibel",
          },
          actions: [
            {
              type: "delete",
              label: "حذف آگهی",
              route: "/notif/delete",
              key: "notif_id",
            },
            {
              type: "show",
              link: "/notif/update",
              label: "مشاهده آگهی",
            },
            {
              type: "rejectAds",
              link: "/notif/update",
              label: "غیر فعال کردن آگهی",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "title",
              label: "دسته بندی",
              objectKey: "city",
            },

            {
              key: "updated_ay",
              type: "date",
              label: "آخرین ویرایش",
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
          ],
        },
        {
          route: "/notif/list-hide",
          type: "table",
          show: true,
          label: "آگهی های غیر فعال",
          api: {
            route: "/advertising/admin_list_hidde",
          },
          actions: [
            {
              type: "delete",
              label: "حذف آگهی",
              route: "/notif/delete",
              key: "notif_id",
            },
            {
              type: "show",
              link: "/notif/update",
              label: "مشاهده آگهی",
            },
            {
              type: "showAds",
              link: "/notif/update",
              label: "فعال کردن آگهی",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "title",
              label: "دسته بندی",
              objectKey: "city",
            },

            {
              key: "updated_ay",
              type: "date",
              label: "آخرین ویرایش",
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
          ],
        },
        {
          route: "/notif/list-reject",
          type: "table",
          show: true,
          label: "آگهی های رد شده",
          api: {
            route: "/advertising/admin_list_rejected",
          },
          actions: [
            {
              type: "delete",
              label: "حذف آگهی",
              route: "/notif/delete",
              key: "notif_id",
            },
            {
              type: "show",
              link: "/notif/update",
              label: "مشاهده آگهی",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "title",
              label: "دسته بندی",
              objectKey: "city",
            },

            {
              key: "updated_ay",
              type: "date",
              label: "آخرین ویرایش",
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
          ],
        },
        {
          route: "/notif/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش آگهی ها",
          box: {
            title: "لیست آگهی ها",
            route: "/notif/list",
          },
          api: {
            needs: ["tags", "categoriesChildrens"],
            route: "/advertising/edit",
            show: {
              route: "/advertising/show",
              key: "id",
            },
          },
          sortInint: (state) => {
            return {
              ...state,
              // main_image: state?.main_image?.url,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "content",
              label: "متن",
              type: "textarea",
            },
            {
              key: "category_id",
              label: "دسته بندی آگهی",
              type: "select",
              need: "categoriesChildrens",
            },
            {
              key: "fullname",
              label: "ثبت کننده",
              nested: "clientfull"
            },
            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
            {
              key: "model",
              label: "نوع آگهی",
              type: "select",
              options: [
                {
                  name: "فروش",
                  key: "sale",
                },
                {
                  name: "درخواست",
                  key: "request",
                },
                {
                  name: "اجاره",
                  key: "rent",
                },
                {
                  name: "معرفی",
                  key: "introduction",
                },
                {
                  name: "خرید",
                  key: "buy",
                },
                {
                  name: "سایر",
                  key: "other",
                },
              ],
            },
            {
              key: "addres",
              label: "آدرس",
            },
            {
              key: "",
              type: "region",
              noNeed: true,
            },
            {
              key: "keywords",
              type: "keywords",
              label: "کلمات کلیدی",
            },
            {
              key: "type",
              label: "نوع آگهی دهنده",
              type: "select",
              options: [
                {
                  name: "شخصی",
                  key: "personal",
                },
                {
                  name: "شرکتی",
                  key: "company",
                },
              ],
            },
            {
              key: "fullname",
              label: "نام و نام خانوادگی",
              exist: {
                key: "type",
                value: "personal",
              },
              noNeed: true,
            },
            {
              key: "mobile",
              label: "موبایل",
              exist: {
                key: "type",
                value: "personal",
              },
              noNeed: true,
            },
            {
              key: "email",
              label: "ایمیل",
              exist: {
                key: "type",
                value: "personal",
              },
              noNeed: true,
            },

            {
              key: "co_name",
              label: "نام شرکت",
              exist: {
                key: "type",
                value: "company",
              },

              noNeed: true,
            },
            {
              key: "co_tell",
              label: "تلفن شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },
            {
              key: "co_mobile",
              label: "موبایل شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },
            {
              key: "co_addres",
              label: "آدرس شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },
            {
              key: "co_url",
              label: "وبسایت شرکت",
              exist: {
                key: "type",
                value: "company",
              },
              noNeed: true,
            },

            {
              key: "price",
              label: "قیمت (تومان)",
            },

            {
              key: "main_image",
              label: "تصویر اصلی",
              type: "images",
            },
            {
              key: "product_images",
              label: "تصاویر دیگر",
              type: "images",
              multi: true,
            },
          ],
        },
      ],
    },
    {
      label: "امکانات ویژه آگهی",
      icon: "",
      nested: true,
      icon: "fab fa-figma",
      options: [
        {
          route: "/option/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش امکانات ویژه آگهی",
          api: {
            route: "/advertising/option/update",
            show: {
              route: "/advertising/option/show",
              key: "id",
            },
          },
          sortInint: (state) => {
            return {
              ...state,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "price",
              label: "قیمت (تومان)",
            },
            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
          ],
        },
        {
          route: "/option/list",
          type: "table",
          show: true,
          label: "لیست امکانات ویژه آگهی",
          api: {
            route: "/advertising/option/list",
          },
          actions: [
            {
              type: "show",
              label: "edit category",
              link: "/option/update",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "price",
              label: "قیمت",
              type: "amount",
              amount: "تومان",
            },
            {
              key: "created_at",
              label: "زمان ایجاد",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "آخرین ویرایش",
            },
          ],
        },
      ],
    },
    {
      label: "کاربران",
      nested: true,
      icon: "far fa-user",
      options: [
        {
          route: "/user/create",
          type: "form",
          show: true,
          label: "ایجاد کاربر",
          api: {
            route: "/client/store",
          },
          box: {
            route: "/user/list",
            title: "لیست کاربران",
          },
          form: [
            {
              key: "fullname",
              label: "نام",
            },
            {
              key: "lastname",
              label: "نام خانوادگی",
            },
            {
              key: "mobile",
              label: "موبایل",
            },
            {
              key: "email",
              label: "ایمیل",
            },

            {
              key: "role",
              label: "نوع کاربر",
              type: "select",
              options: [
                {
                  name: "ادمین",
                  key: "admin",
                },
                {
                  name: "کاربر",
                  key: "user",
                },
              ],
            },
            {
              key: "password",
              label: "کلمه عبور",
              noNeed: true,
              exist: {
                key: "role",
                value: "admin",
              },
            },
            {
              label: "تاریخ تولد",
              key: "br_day",
              type: "date",
              single: true,
            },
            {
              key: "sex",
              label: "جنسیت",
              type: "select",
              options: [
                {
                  name: "مرد",
                  key: "male",
                },
                {
                  name: "زن",
                  key: "female",
                },
              ],
            },
            {
              key: "photo",
              label: "عکس پروفایل",
              type: "images",
              noNeed: true,
            },
          ],
        },
        {
          route: "/user/list",
          type: "table",
          show: true,
          label: "لیست کاربران",
          api: {
            route: "/client/list",
          },
          actions: [
            {
              type: "delete",
              label: "حذف کاربر",
              route: "/client/delete",
              key: "user_id",
            },
            {
              type: "toggle",
              depened: {
                key: "status",
                on: "غیر فعال کردن کاربر",
                off: "فعال کردن کاربر",
              },
              key: "user_id",
              route: "/client/toggle",
            },
            {
              type: "access",
              label: "generate password",
            },
            {
              type: "show",
              link: "/user/update",
              label: "show profile",
              keyGo: "id",
            },
          ],
          header: [
            {
              key: "fullname",
              label: "نام",
            },

            {
              key: "mobile",
              label: "موبایل",
            },
            {
              key: "status",
              type: "status",
              label: "وضعیت",
            },
            {
              key: "isadmin",
              label: "نوع کاربر",
              type: "isadmin",
              enum: ["ادمین", "کاربر"],
              default: "user",
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "آخرین ویرایش",
            },
          ],
        },
        {
          route: "/user/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش کاربر",
          box: {
            title: "لیست کاربران",
            route: "/user/list",
          },
          api: {
            route: "/client/profile/edit",
            show: {
              route: "/client/profile",
              key: "user_id",
            },
          },
          sortInint: (state) => {
            return {
              ...state,
              photo: state.photo ? state?.photo[0] : "",
              user_id: state.id,
            };
          },
          form: [
            {
              key: "fullname",
              label: "نام",
            },

            {
              key: "mobile",
              label: "موبایل",
            },
            {
              key: "email",
              label: "ایمیل",
            },

            {
              key: "role",
              label: "نوع کاربر",
              type: "select",
              options: [
                {
                  name: "ادمین",
                  key: "admin",
                },
                {
                  name: "کاربر",
                  key: "user",
                },
              ],
            },
            {
              key: "br_day",
              type: "date",
              single: true,
            },
            {
              key: "sex",
              label: "جنسیت",
              type: "select",
              options: [
                {
                  name: "مرد",
                  key: "male",
                },
                {
                  name: "زن",
                  key: "female",
                },
              ],
            },
            {
              key: "photo",
              label: "عکس پروفایل",
              type: "images",
              noNeed: true,
            },
          ],
        },
      ],
    },
    {
      label: "دسته بندی",
      icon: "",
      nested: true,
      icon: "fas fa-plus-square",
      options: [
        {
          route: "/category/create",
          type: "form",
          show: true,
          label: "ایجاد دسته بندی",
          api: {
            route: "/category/store",
            needs: ["categories_parent"],
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "keywords",
              type: "keywords",
              label: "کلمات کلیدی",
              nested: "seo",
            },
            {
              label: "توضیحات ",
              type: "textarea",
              key: "description",
            },
            {
              key: "image_alt",
              label: "متن جایگزین تصویر",
            },

            {
              key: "image",
              label: "تصویر دسته بندی",
              type: "images",
            },
            {
              key: "subCategory",
              label: "زیر دسته",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "parent_id",
              type: "select",
              need: "categories_parent",
              exist: {
                key: "subCategory",
                value: "true",
              },
              label: "والد را انتخاب کنید",
              noNeed: true,
            },
            {
              key: "need_paln",
              label: "نیاز به اشتراک دارد؟",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "need_expense",
              label: "دسته بندی پولی است؟",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "price",
              exist: {
                key: "need_expense",
                value: "true",
              },
              noNeed: true,

              label: "قیمت دسته بندی (تومان)",
            },
          ],
        },
        {
          route: "/category/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش دسته بندی",
          api: {
            route: "/category/edit",
            show: {
              route: "/category/show",
              key: "category_id",
            },
            needs: ["categories_parent"],
          },
          sortInint: (state) => {
            return {
              ...state,
              image_alt: state?.image?.alt || "",
              image: state?.image?.url || false,
              category_id: state.id,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "keywords",
              type: "keywords",
              label: "کلمات کلیدی",
              nested: "seo",
            },
            {
              label: "توضیحات ",
              type: "textarea",
              key: "description",
            },
            {
              key: "image_alt",
              label: "متن جایگزین تصویر",
            },

            {
              key: "image",
              label: "تصویر دسته بندی",
              type: "images",
            },
            {
              key: "subCategory",
              label: "زیر دسته",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "parent_id",
              type: "select",
              need: "categories_parent",
              exist: {
                key: "subCategory",
                value: "true",
              },
              filter: "self",
              label: "والد را انتخاب کنید",
              noNeed: true,
            },
            {
              key: "need_plan",
              label: "نیاز به اشتراک دارد؟",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "need_expense",
              label: "دسته بندی پولی است؟",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "price",
              exist: {
                key: "need_expense",
                value: "true",
              },
              noNeed: true,

              label: "قیمت دسته بندی (تومان)",
            },
          ],
        },
        {
          route: "/category/list",
          type: "table",
          show: true,
          label: "لیست دسته بندی",
          api: {
            route: "/category/list",
          },
          actions: [
            {
              type: "delete",
              label: "delete category",
              route: "/category/delete",
              key: "category_id",
            },
            {
              type: "show",
              label: "edit category",
              link: "/category/update",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "created_at",
              label: "زمان ایجاد",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "آخرین ویرایش",
            },
          ],
        },
      ],
    },

    {
      label: "دسته بندی مقالات",
      icon: "",
      nested: true,
      icon: "fas fa-plus-square",
      options: [
        {
          route: "/blog-category/create",
          type: "form",
          show: true,
          label: "ایجاد دسته بندی مقاله",
          api: {
            route: "/blogcategory/store",
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "keywords",
              type: "keywords",
              label: "کلمات کلیدی",
              nested: "seo",
            },
            {
              label: "توضیحات ",
              type: "textarea",
              key: "description",
            },
            {
              key: "imagealt",
              label: "متن جایگزین تصویر",
            },

            {
              key: "image",
              label: "تصویر دسته بندی",
              type: "images",
            },
          ],
        },
        {
          route: "/blog-category/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش دسته بندی",
          api: {
            route: "/blogcategory/edit",
            show: {
              route: "/blogcategory/show",
              key: "blogcategory_id",
            },
          },
          sortInint: (state) => {
            return {
              ...state,
              imagealt: state?.image?.alt || "",
              image: state?.image?.url || false,
              blogcategory_id: state.id,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "keywords",
              type: "keywords",
              label: "کلمات کلیدی",
              nested: "seo",
            },
            {
              label: "توضیحات",
              type: "textarea",
              key: "description",
            },
            {
              key: "imagealt",
              label: "متن جایگزین تصویر",
            },

            {
              key: "image",
              label: "تصویر دسته بندی",
              type: "images",
            },
          ],
        },
        {
          route: "/blog-category/list",
          type: "table",
          show: true,
          label: "لیست دسته بندی مقالات",
          api: {
            route: "/blogcategory/list",
          },
          actions: [
            {
              type: "delete",
              label: "delete category",
              route: "/blogcategory/delete",
              key: "blogcategory_id",
            },
            {
              type: "show",
              label: "edit category",
              link: "/blog-category/update",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "created_at",
              label: "زمان ایجاد",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "آخرین ویرایش",
            },
          ],
        },
      ],
    },
    {
      label: "مقالات",
      nested: true,
      icon: "far fa-clone",
      options: [
        {
          route: "/blog/create",
          type: "form",
          show: true,
          label: "ایجاد مقاله",
          api: {
            route: "/blog/store",
            needs: ["tags", "blog_categories"],
          },
          sort: (state) => {
            return {
              ...state,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "category_id",
              label: "دسته بندی مقاله",
              type: "select",
              need: "blog_categories",
            },
            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
            {
              key: "content",
              label: "متن مقاله",
              type: "editor",
            },
            {
              key: "image",
              label: "تصویر مقاله",
              type: "images",
            },
            {
              key: "image_alt",
              label: "متن جایگزین تصویر",
            },
            {
              key: "tags",
              type: "keywords",
              label: "کلمات کلیدی",
            },
            {
              label: "توضیحات سئو",
              type: "textarea",
              nested: "seo",
              key: "seoDescription",
            },
          ],
        },
        {
          route: "/blog/list",
          type: "table",
          show: true,
          label: "لیست مقالات",
          api: {
            route: "/blog/adminlist",
          },
          actions: [
            {
              type: "delete",
              label: "حذف مقاله",
              route: "/blog/delete",
              key: "blog_id",
            },
            {
              type: "show",
              link: "/blog/update",
              label: "ویرایش مقاله",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "fullname",
              label: "نویسنده",
              type: "nested",
              objectKey: "auther",
            },
            {
              key: "title",
              label: "دسته بندی",
              type: "nested",
              objectKey: "category",
            },
            {
              key: "created_at",
              label: "created_at",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "last upadte",
            },
          ],
        },
        {
          route: "/blog/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش مقاله",
          api: {
            route: "/blog/update",
            show: {
              route: "/blog/edit",
              key: "blog_id",
            },
            needs: ["tags", "blog_categories"],
          },
          sortInint: (state) => {
            return {
              ...state,
              image_alt: (state?.image[0] && state?.image[0].alt) || "",
              image: (state?.image[0] && state?.image[0].url) || false,
              blog_id: state.id,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "category_id",
              label: "دسته بندی مقاله",
              type: "select",
              need: "blog_categories",
            },
            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
            {
              key: "content",
              label: "متن مقاله",
              type: "editor",
            },
            {
              label: "تصویر مقاله",
              type: "images",
              key: "image",
            },
            {
              key: "image_alt",
              label: "متن جایگزین تصویر",
            },
            {
              key: "tags",
              type: "keywords",
              label: "کلمات کلیدی",
            },
            {
              label: "توضیحات سئو",
              type: "textarea",
              nested: "seo",
              key: "seoDescription",
            },
          ],
        },
      ],
    },
    {
      label: "مدیریت تخفیف ها",
      icon: "fas fa-gift",
      nested: true,
      options: [
        {
          route: "/offer/create",
          type: "form",
          show: true,
          label: "ایجاد تخفیف",
          api: {
            needs: ["cource"],
            route: "/off/store",
          },
          box: {
            route: "/off/list",
            title: "تخفیف ها",
          },
          form: [
            {
              key: "code",
              label: "کد تخفیف",
            },
            {
              key: "type_discount",
              label: "نوع تخفیف",
              type: "select",
              options: [
                {
                  name: "درصدی",
                  key: "percentage",
                },
                {
                  name: "پولی",
                  key: "money",
                },
              ],
            },
            {
              key: "amount_discount",
              label: "میزان تخفیف",
              effect: {
                percentage: {
                  name: "درصد",
                },
                money: {
                  name: "تومان",
                },
              },
            },
            {
              key: "max_offer_amount",
              label: "حداکثر مقدار تخفیف(تومان)",
              exist: {
                key: "type_discount",
                value: "percentage",
              },
              noNeed: true,
            },
            {
              key: "product_type",
              label: "برای",
              type: "select",
              options: [
                {
                  name: "همه",
                  key: "all",
                },
                {
                  name: "پلن ها ",
                  key: "plan",
                },
                {
                  name: "آگهی ها",
                  key: "ads",
                },
              ],
            },
            {
              key: "count_allowed",
              label: "تعداد مجاز استفاده",
            },
            {
              key: ["pro_time", "exp_time"],
              label: "تاریخ شروع و پایان",
              type: "date",
            },
          ],
        },
        {
          route: "/off/list",
          type: "table",
          show: true,
          label: "تخفیف ها",
          api: {
            route: "/off/list",
          },
          actions: [
            {
              type: "delete",
              label: "حذف تخفیف",
              route: "/off/delete",
              key: "id",
            },
          ],
          header: [
            {
              key: "code",
              label: "کد تخفیف",
            },
            {
              key: "type_discount",
              label: "نوع تخفیف",
              type: "enum",
              enum: {
                percentage: "درصدی",
                money: "پولی",
              },
            },
            {
              key: "amount_discount",
              label: "مقدار",
            },
            {
              key: "pro_time",
              label: "تاریخ شروع",
              type: "exact-date",
            },
            {
              key: "exp_time",
              type: "exact-date",
              label: "تاریخ پایان",
            },
          ],
        },
      ],
    },
    {
      icon: "fas fa-crown",
      nested: true,
      label: "پلن",
      options: [
        {
          route: "/plan/create",
          type: "form",
          show: true,
          label: "ایجاد پلن",
          api: {
            route: "/plan/store",
          },
          form: [
            {
              key: "status",
              label: "وضعیت(فعال/غیرفغال)",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "type",
              label: "نوع پلن",
              type: "select",
              options: [
                {
                  name: "عضویت",
                  key: "plan",
                },
                {
                  name: "تبلیغات",
                  key: "adverb",
                },
              ],
            },
            {
              key: "price",
              label: "قیمت (تومان)",
            },
            {
              key: "period",
              label: "زمان (روز)",
            },
            {
              label: "توضیحات ",
              type: "textarea",
              key: "description",
            },
            {
              key: "image_alt",
              label: "متن جایگزین تصویر",
            },

            {
              key: "image",
              label: "تصویر  پلن",
              type: "images",
            },
          ],
        },
        {
          route: "/plan/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش پلن",
          api: {
            route: "/plan/update",
            show: {
              route: "/plan/edit",
              key: "id",
            },
          },
          sortInint: (state) => {
            return {
              ...state,
              image_alt: state?.image?.alt || "",
              image: state?.image?.url || false,
            };
          },
          form: [
            {
              key: "status",
              label: "وضعیت(فعال/غیرفغال)",
              noNeed: true,
              type: "toggle",
            },
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "price",
              label: "قیمت (تومان)",
            },
            {
              key: "period",
              label: "زمان (روز)",
            },
            {
              label: "توضیحات ",
              type: "textarea",
              key: "description",
            },
            {
              key: "image_alt",
              label: "متن جایگزین تصویر",
            },

            {
              key: "image",
              label: "تصویر  پلن",
              type: "images",
            },
          ],
        },
        {
          route: "/plan/list",
          type: "table",
          show: true,
          label: "لیست پلن ها",
          api: {
            route: "/plan/adminlist",
          },
          actions: [
            {
              type: "delete",
              label: "delete category",
              route: "/plan/delete",
              key: "id",
            },
            {
              type: "show",
              label: "edit category",
              link: "/plan/update",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "price",
              label: "قیمت",
              amount: "تومان",
              type: "amount",
            },
            {
              key: "period",
              label: "زمان",
              amount: "روز",
              type: "amount",
            },
            {
              key: "status",
              label: "وضعیت",
              type: "zero",
              enum: ["فعال", "غیر فعال"],
              default: "user",
            },
            {
              key: "type",
              label: "نوع",
              type: "zero",
              enum: ["عضویت", "تبلیغات"],
              default: "plan",
            },
            {
              key: "created_at",
              label: "زمان ایجاد",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "آخرین ویرایش",
            },
          ],
        },
      ],
    },
    {
      icon: "fas fa-users",
      nested: true,
      label: "مدیریت همکاران",
      options: [
        {
          route: "/partners/create",
          type: "form",
          show: true,
          label: "ثبت همکار",
          api: {
            route: "/partners/store",
          },
          box: {
            route: "/partners/list",
            title: "لیست همکاران",
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
            {
              key: "logo",
              label: "لوگو",
              type: "images",
            },
            {
              key: "image_alt",
              label: "متن جایگزین لوگو",
            },
          ],
        },
        {
          route: "/partners/list",
          type: "table",
          show: true,
          label: "لیست همکاران",
          api: {
            route: "/partners/list",
          },
          actions: [
            {
              type: "delete",
              label: "حذف آگهی",
              route: "/partners/delete",
              key: "partner_id",
            },
            {
              type: "show",
              link: "/partners/update",
              label: "show profile",
            },
          ],
          header: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
          ],
        },
        {
          route: "/partners/update/:id",
          type: "edit",
          show: false,
          label: "ویرایش همکار",
          box: {
            title: "لیست همکاران",
            route: "/partners/list",
          },
          api: {
            route: "/partners/edit",
            show: {
              route: "/partners/show",
              key: "id",
            },
          },
          sortInint: (state) => {
            return {
              ...state,
              logo: state.logo.url,
              image_alt: state.logo.alt,
            };
          },
          form: [
            {
              key: "title",
              label: "عنوان",
            },

            {
              key: "description",
              label: "توضیحات",
              type: "textarea",
            },
            {
              key: "logo",
              label: "لوگو",
              type: "images",
            },
            {
              key: "image_alt",
              label: "متن جایگزین لوگو",
            },
          ],
        },
      ],
    },
    {
      label: "تنظیمات",
      icon: "fas fa-cogs",
      nested: true,
      options: [
        {
          route: "/settings/about_us",
          type: "edit",
          show: true,
          label: "درباره ما",
          api: {
            route: "/setting/update",
            show: {
              route: "/setting/inputanddata",
            },
            initial: { key: "about_us" },
          },
          sortInint: (state) => {
            return {
              ...sortSettings(state),
            };
          },
          sort: (state) => {
            return { ...state, key: "about_us" };
          },
          form: [
            {
              key: "text",
              label: "متن درباره ما",
              type: "textarea",
            },
          ],
        },
        {
          route: "/settings/contact-us",
          type: "edit",
          show: true,
          label: "ارتباط با ما",
          api: {
            route: "/setting/update",
            show: {
              route: "/setting/inputanddata",
            },
            initial: { key: "contact_us" },
          },
          sortInint: (state) => {
            return {
              ...sortSettings(state),
            };
          },
          sort: (state) => {
            return { ...state, key: "contact_us" };
          },
          form: [
            {
              key: "support_number",
              label: "تلفن پشتیبانی",
            },
            {
              key: "email",
              label: "ایمیل",
            },
            {
              key: "fax",
              label: "فکس",
            },
            {
              key: "addres",
              label: "آدرس",
            },
            {
              key: "wotk_time",
              label: "ساعت کاری",
            },
            {
              key: "notif",
              label: "اطلاعیه",
            },
          ],
        },
        {
          route: "/settings/social-media",
          type: "edit",
          show: true,
          label: "شبکه های اجتماعی",
          api: {
            route: "/setting/update",
            show: {
              route: "/setting/inputanddata",
            },
            initial: { key: "social_media" },
          },
          sortInint: (state) => {
            return {
              ...sortSettings(state),
            };
          },
          sort: (state) => {
            return { ...state, key: "social_media" };
          },
          form: [
            {
              key: "instagram",
              label: "اینستاگرام",
            },
            {
              key: "linkedin",
              label: "لینکدین",
            },
            {
              key: "telegram",
              label: "تلگرام",
            },
            {
              key: "whatsapp",
              label: "شماره واتساب",
            },
          ],
        },
      ],
    },
    {
      label: "پشتیبانی",
      route: "/support",
      nested: true,
      icon: "fas fa-headset",
      options: [
        {
          route: "/support",
          type: "table",
          elements: [],
          show: true,
          api: {
            route: "/support/admin_list",
          },
          filters: [
            {
              type: "select",
              need: "departman",
              key: "departman_id",
              label: "دپارتمان",
              options: [],
            },
          ],
          label: "تیکت ها",
          actions: [
            {
              type: "show",
              link: "/support",
              label: "show profile",
            },
          ],
          header: [
            {
              key: "fullname",
              type: "nested",
              label: "نام",
              objectKey: "usertiketer",
            },

            {
              key: "title",
              label: "عنوان",
            },
            {
              key: "departman",
              label: "دپارتمان",
              type: "enum",
              enum: {
                sale: "فروش",
                technical: "فنی",
                Financial: "مالی",
                experts: "فروشنده",
              },
            },
            {
              key: "status",
              label: "وضعیت",
              type: "enum",
              enum: {
                waiting: "در انتظار پاسخ",
                answerd: "پاسخ داده شده",
                closed: "بسته شده",
              },
            },
            {
              key: "created_at",
              label: "تاریخ ایجاد",
              type: "date",
            },
            {
              key: "updated_at",
              type: "date",
              label: "آخرین بروزرسانی",
            },
          ],
        },
        {
          type: "ticketing",
          route: "support/:id",
        },
      ],
    },
    {
      icon: "fas fa-envelope-open-text",
      nested: false,
      route: "/messages",
      label: "پیام های ارتباط ما",

      options: [
        {
          route: "/messages",
          type: "table",
          show: true,
          label: "لیست پیام ها",
          api: {
            route: "/connectus/list",
          },
          header: [
            {
              key: "fullname",
              label: "نام",
            },

            {
              key: "mobile",
              label: "موبایل",
            },
            {
              key: "description",
              label: "توضیحات",
            },
            {
              key: "message",
              label: "پیام",
            },
          ],
        },
      ],
    },
  ],
};
const Panel = () => {
  const renderRoute = (option) => {
    switch (option.type) {
      case "form":
        return (
          <Route
            path={option.route}
            element={
              <Layout stracture={stracture}>
                <Form options={option} />
              </Layout>
            }
          />
        );
      case "edit":
        return (
          <Route
            path={option.route}
            element={
              <Layout>
                <Form options={option} edit={true} />
              </Layout>
            }
          />
        );
      case "table":
        return (
          <Route
            path={option.route}
            element={
              <Layout>
                <Table options={option} />
              </Layout>
            }
          />
        );
      case "dashboard":
        return (
          <Route
            path={option.route}
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
        );
      case "ticketing":
        return (
          <Route
            path={option.route}
            element={
              <Layout>
                <Support />
              </Layout>
            }
          />
        );
      case "surface":
        return (
          <Route
            path={option.route}
            element={
              <Layout>
                <Surfaces option={option} />
              </Layout>
            }
          />
        );

      default:
        break;
    }
  };
  return (
    <>
      <Routes>
        <Route path="*" element={<NotFound />} />
        {stracture &&
          stracture.pages.map((page) => {
            return page.options.map((option) => {
              if (option) {
                return renderRoute(option);
              }
            });
          })}
      </Routes>
    </>
  );
};

export default Panel;
